"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const vue_3 = require("vue");
const index_1 = require("../../utils/index");
exports.default = (0, vue_1.defineComponent)({
    __name: 'index',
    props: {
        placeholder: String,
        options: {
            type: Array,
            default: []
        },
        handleChange: {
            type: Function,
            default: () => { }
        },
        inputChange: Function,
        canOpen: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            default: '282px'
        },
        showSelect: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['getSelectState'],
    setup(__props, { emit: __emit }) {
        const open = (0, vue_3.ref)(false);
        const searchValue = (0, vue_3.ref)("");
        const props = __props;
        //监听showSelect为false时说明用户点击了取消，需要清空搜索文本
        (0, vue_3.watch)(() => props.showSelect, (newValue) => {
            if (!newValue) {
                searchValue.value = '';
            }
        });
        const onBlur = () => {
            open.value = false;
            // emits('getSelectState', false)
        };
        const userSelect = (value) => {
            props.handleChange(value);
            open.value = false;
        };
        const antiShakeInputChange = (0, index_1.antiShake)((value) => {
            props.inputChange(value);
            if (value !== "") {
                if (props.canOpen) {
                    open.value = true;
                }
            }
        }, 100);
        const onFocus = () => {
            emits('getSelectState', true);
        };
        const emits = __emit;
        return (_ctx, _cache) => {
            const _component_SearchOutlined = (0, vue_2.resolveComponent)("SearchOutlined");
            const _component_a_select = (0, vue_2.resolveComponent)("a-select");
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_a_select, (0, vue_2.mergeProps)(props, {
                class: "searchBox",
                popupClassName: "popup_className",
                "show-search": "",
                style: { width: __props.width },
                "filter-option": false,
                onSearch: _cache[0] || (_cache[0] = (value) => {
                    searchValue.value = value;
                    (0, vue_2.unref)(antiShakeInputChange)(value);
                }),
                onChange: _cache[1] || (_cache[1] = (value) => { userSelect(value); }),
                onBlur: onBlur,
                onFocus: onFocus,
                open: open.value,
                searchValue: searchValue.value
            }), {
                suffixIcon: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(_component_SearchOutlined, { style: { "color": "#FFFFFF", "font-size": "20px" } })
                ]),
                _: 1
            }, 16, ["style", "open", "searchValue"]));
        };
    }
});
